import { create } from "zustand";

declare global {
  interface Window {
    __HOST_THEME__?: string;
  }
}

type SettingsStore = {
  isDarkMode: boolean;
  setDarkMode: (isDarkMode: boolean) => void;
};

const useSettingsStore = create<SettingsStore>((set) => ({
  isDarkMode: false,
  setDarkMode: (isDarkMode) => {
    // Store the current theme on the global window object
    if (typeof window !== "undefined") {
      window.__HOST_THEME__ = isDarkMode ? "dark" : "light";
      window.dispatchEvent(
        new CustomEvent("theme-change", { detail: window.__HOST_THEME__ })
      );
    }

    set({ isDarkMode });
  },
}));

// Set default on load
if (typeof window !== "undefined") {
  window.__HOST_THEME__ = "light";
}

export default useSettingsStore;
